export default __webpack_public_path__ + "static/media/02-smoke-adpt2.98e95ed1.gif";